/**
 * Orders API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  cancelOrder,
  createOrder,
  deleteOrder,
  getOrderById,
  getOrders,
  processOrder,
  reissueOrder,
  updateOrder,
} from "../generated/orders/orders";

import { wrapListMethod, wrapMethod } from "./utils";

export const orders = {
  /** @see createOrder */
  create: wrapMethod(createOrder),

  /** @see getOrders */
  list: wrapListMethod(getOrders),

  /** @see getOrderById */
  get: wrapMethod(getOrderById),

  /** @see updateOrder */
  update: wrapMethod(updateOrder),

  /** @see deleteOrder */
  delete: wrapMethod(deleteOrder),

  /** @see processOrder */
  processOrder: wrapMethod(processOrder),

  /** @see cancelOrder */
  cancelOrder: wrapMethod(cancelOrder),

  /** @see reissueOrder */
  reissueOrder: wrapMethod(reissueOrder),
} as const;

export type OrdersApi = typeof orders;
